import { lazy } from 'react';

import QALink from 'components/QALink';

import Auth from 'ux/Auth';
import Logout from 'ux/Auth/Logout';
import Page404 from 'ux/Page/404';
import Page500 from 'ux/Page/500';
import AboutUs from 'ux/Public/AboutUs';
import AddProperty from 'ux/Public/AddProperty';
import AnnualReport from 'ux/Public/AnnualReport';
import BlogArticle from 'ux/Public/Blog/Article';
import BlogLanding from 'ux/Public/Blog/Landing';
import Brokers from 'ux/Public/Brokers';
import CaseStudies from 'ux/Public/CaseStudies';
import CityPage from 'ux/Public/CityPage';
import CommercialRealEstate from 'ux/Public/CommercialRealEstate';
import Compare from 'ux/Public/Compare';
import CompareDetail from 'ux/Public/CompareDetail';
import PublicHome from 'ux/Public/Home';
import HowItWorks from 'ux/Public/HowItWorks';
import Listing from 'ux/Public/Listing';
import STBListing from 'ux/Public/Listing/STB';
import STBRequest from 'ux/Public/Listing/STB/STBRequest';
import Location from 'ux/Public/Location';
import NYCTechWeek from 'ux/Public/NYCTechWeek';
import NotificationPreferences from 'ux/Public/NotificationPreferences';
import OfficeRequest from 'ux/Public/OfficeRequest';
import Offsites from 'ux/Public/Offsites';
import Playbook from 'ux/Public/Playbook';
import PlaybookLandingPage from 'ux/Public/Playbook/PlaybookLandingPage';
import Press from 'ux/Public/Press';
import Privacy from 'ux/Public/Privacy';
import ReferralLanding from 'ux/Public/ReferralLanding';
import SFTechWeek from 'ux/Public/SFTechWeek';
import ServicesRequest from 'ux/Public/ServicesRequest';
import Terms from 'ux/Public/Terms';
import Testimonials from 'ux/Public/Testimonials';
import Search from 'ux/Search';
import SearchEntry from 'ux/Search/SearchEntry';
import AIAssistant from 'ux/Tenant/AIAssistant';
import CleaningServiceCheckoutPage from 'ux/Tenant/CleaningService/Onboarding/CleaningServiceCheckoutPage';
import CleaningServiceSetUp from 'ux/Tenant/CleaningService/Onboarding/CleaningServiceSetUp';
import TenantEmployeeComingSoon from 'ux/Tenant/ComingSoon';
import TenantWelcomePage from 'ux/Tenant/Onboarding/TenantWelcomePage';
import ConsumablesOnboardingSetPage from 'ux/Tenant/PantryAndSupplies/Onboarding/ConsumablesOnboardingSetPage';
import ConsumablesStartSubscriptionPage from 'ux/Tenant/PantryAndSupplies/Onboarding/ConsumablesStartSubscriptionPage';
import ConsumablesOrderPage from 'ux/Tenant/PantryAndSupplies/Orders/ConsumablesOrderPage';
import PaymentMethods from 'ux/Tenant/PaymentMethods';
import TenantAdminPaymentMethods from 'ux/Tenant/TenantAdmin/PaymentMethods';

import {
  ABOUT_US_PATH,
  ACCOUNT_PATH,
  ADD_ON_ORDERS_REDIRECT_PATH,
  ADD_ON_ORDERS_REDIRECT_SLUG_PATH,
  ADD_PROPERTY_PATH,
  ADMIN_PATH,
  AI_ASSISTANT_PATH,
  AI_ASSISTANT_SLUG_PATH,
  ANNUAL_REPORT_PATH,
  AUTH_PATH,
  BLOG_ARTICLE_PATH,
  BLOG_PATH,
  BROKERS_PATH,
  CASE_STUDY_PATH,
  CITY_PAGE_SLUG_PATH,
  CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH,
  CLEANING_SERVICE_PATH,
  CLEANING_SERVICE_SET_UP_PATH,
  COMMERCIAL_REAL_ESTATE_PATH,
  COMPARE_DETAIL_SLUG_PATH,
  COMPARE_PATH,
  CONSUMABLES_CHECKOUT_PATH,
  CONSUMABLES_ONBOARDING_SET_PATH,
  CUSTOMER_ADD_FURNITURE_SLUG_PATH,
  CUSTOMER_CLEANING_REDIRECT_PATH,
  CUSTOMER_CLEANING_SLUG_PATH,
  CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH,
  CUSTOMER_FURNITURE_SLUG_PATH,
  CUSTOMER_OFFICE_REQUEST_ID_PATH,
  CUSTOMER_OFFICE_REQUEST_PATH,
  CUSTOMER_OFFSITES_PATH,
  CUSTOMER_OFFSITES_SLUG_PATH,
  CUSTOMER_ORDERS_PATH,
  CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH,
  CUSTOMER_SUPPORT_PATH,
  CUSTOMER_SUPPORT_SLUG_PATH,
  DASHBOARD_PATH,
  FIVE_HUNDRED_PATH,
  FOUR_ZERO_FOUR_PATH,
  FURNITURE_CHECKOUT_PATH,
  FURNITURE_GET_STARTED_PATH,
  FURNITURE_PATH,
  FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH,
  GFP_PATH,
  HOME_PATH,
  HOW_IT_WORKS_PATH,
  LANDLORD_DASHBOARD_PATH,
  LANDLORD_PAYMENTS_PATH,
  LISTING_PATH,
  LISTING_SLUG_PATH,
  LOCATION_SLUG_PATH,
  LOGOUT_PATH,
  MEMBERSHIP_ADD_ONS_SLUG_PATH,
  MEMBERSHIP_PATH,
  MEMBERSHIP_PLAN_SLUG_PATH,
  NOTIFICATION_PREFERENCES_TOKEN_PATH,
  NYC_TECH_WEEK_PATH,
  OFFICE_REQUEST_PATH,
  OFFSITES_PATH,
  PANTRY_ORDERS_PATH,
  PANTRY_ORDER_SLUG_PATH,
  PANTRY_PATH,
  PANTRY_SHOP_PATH,
  PANTRY_SUBSCRIPTION_EDIT_PATH,
  PANTRY_SUBSCRIPTION_PATH,
  PAYMENTS_PATH,
  PAYMENT_SUMMARY_SLUG_PATH,
  PLAYBOOK_PATH,
  PRESS_PATH,
  PRIVACY_PATH,
  PROPERTIES_PATH,
  QA_LINK,
  REFERRALS_PATH,
  REFERRAL_LANDING_CODE_PATH,
  ROOT_PATH,
  SEARCH_ENTRY_PATH,
  SEARCH_PATH,
  SEARCH_PATH_DEPRECATED,
  SERVICES_REQUEST_PATH,
  SF_TECH_WEEK_PATH,
  STB_REQUEST_PATH,
  STB_REQUEST_SLUG_PATH,
  TENANT_ADMIN_BILLING_SETTINGS_PATH,
  TENANT_ADMIN_PATH,
  TENANT_ADMIN_PAYMENTS_PATH,
  TENANT_ADMIN_PAYMENT_METHODS_PATH,
  TENANT_ADMIN_PLATFORM_FEE_PROPOSAL_SLUG_PATH,
  TENANT_ADMIN_SUMMARIES_PATH,
  TENANT_ADMIN_SUMMARY_DETAIL_PATH,
  TENANT_ADMIN_TEAM_PATH,
  TENANT_EMPLOYEE_COMING_SOON_PATH,
  TENANT_PAYMENT_METHODS_PATH,
  TENANT_WELCOME_PATH,
  TERMS_PATH,
  TESTIMONIALS_PATH,
  VENDOR_PATH
} from './paths';
import { Route } from './types';

const Admin = lazy(() => import('ux/Admin'));
const Account = lazy(() => import('ux/Customer/Account'));
const CustomerOffsites = lazy(() => import('ux/Customer/Offsites'));
const CustomerOffsite = lazy(() => import('ux/Customer/Offsites/CustomerOffsite'));
const Orders = lazy(() => import('ux/Customer/Orders'));
const OrderRedirect = lazy(() => import('ux/Customer/Orders/OrderRedirect'));
const OrdersRedirect = lazy(() => import('ux/Customer/Orders/OrdersRedirect'));
const PaymentSummary = lazy(() => import('ux/Payments/PaymentSummary'));
const Properties = lazy(() => import('ux/Properties'));
const CustomerOfficeRequest = lazy(() => import('ux/Customer/OfficeRequest'));
const Payments = lazy(() => import('ux/Payments'));
const Dashboard = lazy(() => import('ux/Dashboard'));
const PantryAndSupplies = lazy(() => import('ux/Tenant/PantryAndSupplies'));
const Vendor = lazy(() => import('ux/Vendor'));
const Landlord = lazy(() => import('ux/Landlord'));
const AppRedirect = lazy(() => import('ux/Customer/AppRedirect'));
const Referrals = lazy(() => import('ux/Customer/Referrals'));
const Cleaning = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning'));
const CleaningRedirect = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning/CleaningRedirect'));
const Furniture = lazy(() => import('ux/Customer/ServicesAndAmenities/Furniture'));
const ServicesAndAmenities = lazy(() => import('ux/Customer/ServicesAndAmenities'));
const AddFurniturePage = lazy(() => import('ux/Customer/ServicesAndAmenities/Furniture/AddFurniture/AddFurniturePage'));
const EditCleaningSchdule = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning/EditCleaningSchedule'));
const CustomerOfficeRequestsList = lazy(() => import('ux/Customer/OfficeRequest/CustomerOfficeRequestsList'));
const OfficesRedirect = lazy(() => import('ux/Customer/Offices/OfficesRedirect'));
const Membership = lazy(() => import('ux/Customer/Membership'));
const MembershipPlan = lazy(() => import('ux/Customer/Membership/MembershipPlan'));
const MembershipAddOnsPage = lazy(() => import('ux/Customer/Membership/MembershipAddOnsPage'));
const CustomerSupport = lazy(() => import('ux/Customer/Support'));
const CustomerSupportPage = lazy(() => import('ux/Customer/Support/Page'));
const ConsumablesEditSubscriptionPage = lazy(() =>
  import('ux/Tenant/PantryAndSupplies/Subscription/ConsumablesEditSubscriptionPage')
);
const FurnitureCheckoutPage = lazy(() => import('ux/Tenant/FurnitureAndEquipment/FurnitureCheckoutPage'));
const GFPLandingPage = lazy(() => import('ux/Public/GFPLandingPage'));
const CleaningService = lazy(() => import('ux/Tenant/CleaningService'));
const TenantAdmin = lazy(() => import('ux/Tenant/TenantAdmin'));
const TenantAdminPayments = lazy(() => import('ux/Tenant/TenantAdmin/SummariesAndPayments'));
const TenantAdminSummaryDetail = lazy(() => import('ux/Tenant/TenantAdmin/SummariesAndPayments/SummaryDetail'));
const TenantAdminBillingSettings = lazy(() => import('ux/Tenant/TenantAdmin/BillingSettings'));
const TenantAdminTeam = lazy(() => import('ux/Tenant/TenantAdmin/Team'));
const TenantAdminPlatformFeeProposal = lazy(() => import('ux/Tenant/PlatformFeeProposal'));
const FurnitureAndEquipment = lazy(() => import('ux/Tenant/FurnitureAndEquipment'));
const FurnitureGetStartedPage = lazy(() => import('ux/Tenant/FurnitureAndEquipment/FurnitureGetStartedPage'));
const LandlordPayments = lazy(() => import('ux/Landlord/Financials/Payments'));
const ProductSetUI = lazy(() => import('ux/Tenant/FurnitureAndEquipment/ProductSetUI'));

export const ROUTES: Route[] = [
  { path: TENANT_EMPLOYEE_COMING_SOON_PATH, Component: TenantEmployeeComingSoon, requiredRole: 'tenant', exact: true },
  { path: TENANT_ADMIN_PATH, Component: TenantAdmin, requiredRole: 'customerAdmin', exact: true },
  { path: TENANT_ADMIN_PAYMENTS_PATH, Component: TenantAdminPayments, requiredRole: 'customerAdmin', exact: true },
  {
    path: TENANT_ADMIN_SUMMARY_DETAIL_PATH,
    Component: TenantAdminSummaryDetail,
    requiredRole: 'customerAdmin',
    exact: true
  },
  { path: TENANT_ADMIN_SUMMARIES_PATH, Component: TenantAdminPayments, requiredRole: 'customerAdmin', exact: true },
  {
    path: TENANT_ADMIN_BILLING_SETTINGS_PATH,
    Component: TenantAdminBillingSettings,
    requiredRole: 'customerAdmin',
    exact: true
  },
  {
    path: TENANT_ADMIN_PAYMENT_METHODS_PATH,
    Component: TenantAdminPaymentMethods,
    requiredRole: 'customerAdmin',
    exact: true
  },
  { path: TENANT_ADMIN_TEAM_PATH, Component: TenantAdminTeam, requiredRole: 'customerAdmin', exact: true },
  {
    path: TENANT_ADMIN_PLATFORM_FEE_PROPOSAL_SLUG_PATH,
    Component: TenantAdminPlatformFeeProposal,
    requiredRole: 'customerAdmin',
    customLayout: true
  },
  { path: AI_ASSISTANT_PATH, Component: AIAssistant, requiredRole: 'tenantAdmin', exact: true },
  { path: AI_ASSISTANT_SLUG_PATH, Component: AIAssistant, requiredRole: 'tenantAdmin' },
  { path: TENANT_PAYMENT_METHODS_PATH, Component: PaymentMethods, requiredRole: 'customerAdmin' },
  { path: PANTRY_PATH, Component: PantryAndSupplies, requiredRole: 'customerAdmin', exact: true },
  { path: PANTRY_SHOP_PATH, Component: PantryAndSupplies, requiredRole: 'customerAdmin' },
  {
    path: PANTRY_SUBSCRIPTION_EDIT_PATH,
    Component: ConsumablesEditSubscriptionPage,
    requiredRole: 'customerAdmin',
    exact: true
  },
  { path: PANTRY_SUBSCRIPTION_PATH, Component: PantryAndSupplies, requiredRole: 'customerAdmin' },
  { path: PANTRY_ORDERS_PATH, Component: PantryAndSupplies, requiredRole: 'customerAdmin', exact: true },
  { path: PANTRY_ORDER_SLUG_PATH, Component: ConsumablesOrderPage, requiredRole: 'customerAdmin' },
  {
    path: CONSUMABLES_CHECKOUT_PATH,
    Component: ConsumablesStartSubscriptionPage,
    requiredRole: 'customerAdmin',
    customLayout: true
  },
  {
    path: CONSUMABLES_ONBOARDING_SET_PATH,
    Component: ConsumablesOnboardingSetPage,
    requiredRole: 'customerAdmin'
  },
  {
    path: FURNITURE_CHECKOUT_PATH,
    Component: FurnitureCheckoutPage,
    requiredRole: 'tenantAdmin',
    exact: true,
    customLayout: true
  },
  { path: FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH, Component: ProductSetUI, requiredRole: 'tenantAdmin', exact: true },
  { path: FURNITURE_GET_STARTED_PATH, Component: FurnitureGetStartedPage, requiredRole: 'tenantAdmin', exact: true },
  { path: FURNITURE_PATH, Component: FurnitureAndEquipment, requiredRole: 'tenantAdmin' },
  { path: TENANT_WELCOME_PATH, Component: TenantWelcomePage, requiredRole: 'tenantAdmin', customLayout: true },
  {
    path: CLEANING_SERVICE_SET_UP_PATH,
    Component: CleaningServiceSetUp,
    requiredRole: 'tenantAdmin',
    customLayout: true
  },
  {
    path: CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH,
    Component: CleaningServiceCheckoutPage,
    requiredRole: 'tenantAdmin',
    customLayout: true,
    exact: true
  },
  { path: CLEANING_SERVICE_PATH, Component: CleaningService, requiredRole: 'tenantAdmin' },

  { path: ACCOUNT_PATH, Component: Account, requiredRole: 'user', sideBarIsExpandable: false },
  {
    path: ADMIN_PATH,
    Component: Admin,
    requiredRole: 'superAdmin',
    hideFooter: true
  },
  { path: AUTH_PATH, Component: Auth, hideFooter: true, hideHeader: true, customLayout: true, waitForUserLoad: true },
  {
    path: CUSTOMER_OFFICE_REQUEST_PATH,
    Component: CustomerOfficeRequestsList,
    requiredRole: 'employee',
    exact: true
  },
  {
    path: CUSTOMER_OFFICE_REQUEST_ID_PATH,
    Component: CustomerOfficeRequest,
    requiredRole: 'employee',
    exact: true
  },
  {
    path: CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH,
    Component: EditCleaningSchdule,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true,
    showMobileBottomNav: false
  },
  {
    path: CUSTOMER_CLEANING_SLUG_PATH,
    Component: Cleaning,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  { path: CUSTOMER_FURNITURE_SLUG_PATH, Component: Furniture, requiredRole: 'hasCustomerAdminPlans', exact: true },
  {
    path: CUSTOMER_CLEANING_REDIRECT_PATH,
    Component: CleaningRedirect,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  {
    path: CUSTOMER_ADD_FURNITURE_SLUG_PATH,
    Component: AddFurniturePage,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true,
    showMobileBottomNav: false
  },
  {
    path: CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH,
    Component: ServicesAndAmenities,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupport,
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_SLUG_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupportPage,
    exact: true
  },
  { path: PAYMENT_SUMMARY_SLUG_PATH, Component: PaymentSummary, requiredRole: 'hasCustomerAdminPlans' },
  { path: PAYMENTS_PATH, Component: Payments, requiredRole: 'hasCustomerAdminPlans' },
  { path: DASHBOARD_PATH, Component: Dashboard, requiredRole: 'employee' },
  {
    path: PROPERTIES_PATH,
    Component: Properties,
    requiredRole: 'hasWorkspaceRoles',
    sideBarIsExpandable: false
  },
  { path: VENDOR_PATH, Component: Vendor, requiredRole: 'vendor' },
  { path: LANDLORD_DASHBOARD_PATH, Component: Landlord, requiredRole: 'landlord' },
  { path: LANDLORD_PAYMENTS_PATH, Component: LandlordPayments, requiredRole: 'landlord' },
  {
    path: SEARCH_PATH,
    exact: true,
    Component: Search,
    customLayout: true,
    hasFooterMargin: false,
    waitForGoogleMapsLoad: true,
    waitForUserLoad: true
  },
  {
    path: SEARCH_PATH_DEPRECATED,
    Component: Search,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: SEARCH_ENTRY_PATH,
    Component: SearchEntry,
    customLayout: true,
    hasFooterMargin: false,
    hideHeader: true,
    hideFooter: true,
    waitForAnalyticsLoad: false,
    waitForGoogleMapsLoad: false
  },
  {
    path: LISTING_SLUG_PATH,
    Component: Listing,
    hasHeaderCta: false,
    waitForUserLoad: true
  },
  {
    path: LISTING_PATH,
    Component: Listing,
    hasHeaderCta: false,
    waitForUserLoad: true
  },
  {
    path: HOME_PATH,
    Component: AppRedirect,
    requiredRole: 'user',
    exact: true
  },
  { path: CITY_PAGE_SLUG_PATH, Component: CityPage },
  { path: LOCATION_SLUG_PATH, Component: Location, cmsSlug: 'location', hasFooterMargin: false },
  {
    path: ABOUT_US_PATH,
    Component: AboutUs,
    exact: true,
    cmsSlug: 'about-us'
  },
  {
    path: BLOG_PATH,
    Component: BlogLanding,
    exact: true
  },
  {
    path: ANNUAL_REPORT_PATH,
    Component: AnnualReport,
    exact: true,
    hasFooterMargin: false
  },
  { path: BLOG_ARTICLE_PATH, Component: BlogArticle, exact: true },
  { path: CASE_STUDY_PATH, Component: CaseStudies, hasFooterMargin: false },
  {
    path: COMMERCIAL_REAL_ESTATE_PATH,
    Component: CommercialRealEstate,
    exact: true,
    hasFooterMargin: false,
    hasHeaderCta: false
  },
  {
    path: COMPARE_DETAIL_SLUG_PATH,
    Component: CompareDetail,
    exact: true,
    cmsSlug: 'compare-detail',
    hasFooterMargin: false
  },
  {
    path: COMPARE_PATH,
    Component: Compare,
    exact: true,
    cmsSlug: 'compare',
    hasFooterMargin: false
  },
  {
    path: ROOT_PATH,
    Component: PublicHome,
    exact: true,
    customLayout: true,
    hasFooterMargin: false,
    waitForAnalyticsLoad: false
  },
  {
    path: HOW_IT_WORKS_PATH,
    Component: HowItWorks,
    exact: true,
    hasFooterMargin: false
  },
  {
    path: PRESS_PATH,
    Component: Press,
    exact: true,
    cmsSlug: 'press'
  },
  {
    path: PRIVACY_PATH,
    Component: Privacy,
    exact: true,
    cmsSlug: 'privacy-policy'
  },
  {
    path: TERMS_PATH,
    Component: Terms,
    exact: true,
    cmsSlug: 'terms-of-service'
  },
  { path: PLAYBOOK_PATH, Component: PlaybookLandingPage, exact: true, hasFooterMargin: false },
  { path: PLAYBOOK_PATH, Component: Playbook, hideHeader: true, hideFooter: true, customLayout: true },
  {
    path: REFERRAL_LANDING_CODE_PATH,
    Component: ReferralLanding,
    hasHeaderCta: false,
    hasFooterMargin: false,
    customLayout: true
  },
  {
    path: NOTIFICATION_PREFERENCES_TOKEN_PATH,
    Component: NotificationPreferences
  },
  {
    path: OFFICE_REQUEST_PATH,
    Component: OfficeRequest,
    hideFooter: true,
    hideHeader: true,
    customLayout: true
  },
  {
    path: SERVICES_REQUEST_PATH,
    Component: ServicesRequest,
    hideFooter: true,
    hideHeader: true,
    customLayout: true
  },
  {
    path: '/app/offices',
    Component: OfficesRedirect,
    exact: true,
    requiredRole: 'employee'
  },
  {
    path: MEMBERSHIP_PATH,
    Component: Membership,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  { path: MEMBERSHIP_PLAN_SLUG_PATH, Component: MembershipPlan, exact: true, requiredRole: 'hasCustomerAdminPlans' },
  {
    path: MEMBERSHIP_ADD_ONS_SLUG_PATH,
    Component: MembershipAddOnsPage,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: CUSTOMER_OFFSITES_PATH,
    Component: CustomerOffsites,
    exact: true,
    requiredRole: 'user'
  },
  {
    path: CUSTOMER_OFFSITES_SLUG_PATH,
    Component: CustomerOffsite,
    exact: true,
    requiredRole: 'employee'
  },
  {
    path: ADD_ON_ORDERS_REDIRECT_PATH,
    Component: OrdersRedirect,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: ADD_ON_ORDERS_REDIRECT_SLUG_PATH,
    Component: OrderRedirect,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: CUSTOMER_ORDERS_PATH,
    Component: Orders,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: REFERRALS_PATH,
    Component: Referrals,
    exact: true,
    requiredRole: 'employee'
  },
  { path: QA_LINK, Component: QALink, waitForUserLoad: true },
  { path: FIVE_HUNDRED_PATH, Component: Page500 },
  { path: FOUR_ZERO_FOUR_PATH, Component: Page404 },
  {
    path: SF_TECH_WEEK_PATH,
    Component: SFTechWeek,
    customLayout: true,
    exact: true
  },
  {
    path: NYC_TECH_WEEK_PATH,
    Component: NYCTechWeek,
    customLayout: true,
    exact: true
  },
  {
    path: TESTIMONIALS_PATH,
    Component: Testimonials,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  },
  {
    path: BROKERS_PATH,
    Component: Brokers,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: STB_REQUEST_PATH,
    Component: STBRequest,
    hideFooter: true,
    hideHeader: true,
    exact: true,
    customLayout: true
  },
  {
    path: STB_REQUEST_SLUG_PATH,
    Component: STBListing,
    hasFooterMargin: false
  },
  { path: OFFSITES_PATH, Component: Offsites, exact: true, cmsSlug: 'offsites', hasFooterMargin: false },
  { path: ADD_PROPERTY_PATH, Component: AddProperty, customLayout: true, hideFooter: true, hideHeader: true },
  { path: LOGOUT_PATH, Component: Logout, exact: true },
  {
    path: GFP_PATH,
    Component: GFPLandingPage,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  }
];
